import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ConfirmDialogModel } from "@/shared/components/confirm-dialog/confirm-dialog.model";

@Component({
  selector: 'cosmos-dialog',
  styleUrls: ['confirm-dialog.component.scss'],
  templateUrl: 'confirm-dialog.component.html',
})

export class ConfirmDialogComponent {

  public constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel,
  ) {
  }

  public onConfirmClick(result: boolean): void {
    this.dialogRef.close(result);
  }
}
